// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2U_jq","footer":"ModalInfo_footer__67TZ5"};